import { render, staticRenderFns } from "./AdminCompletitionForm.vue?vue&type=template&id=82824a16&"
import script from "./AdminCompletitionForm.vue?vue&type=script&lang=ts&"
export * from "./AdminCompletitionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports